import { observer } from "mobx-react-lite";
import bannerBg from './imgs/banner.png';
import { withT } from "./tools";
import { PirmaryBtn } from "./components/primaryBtn";
import { PageName, applyProjectAddress } from "./configs";

const PageHeader = ({
  t,
}) => {

  const onApplyClick = () => {
    window.open(applyProjectAddress);
  }

  return (
    <div
      className="flex justify-center h-[282px] pt-[64px] sm:pt-[70px] bg-no-repeat bg-center bg-cover"
      style={{
        backgroundImage: `url(${bannerBg})`,
      }}
    >
      <section className="flex flex-col items-center">
        <h1 className="mb-0 text-[#fff] text-[60px] sm:text-[30px] leading-[72px] sm:leading-normal sm:mb-[12px] font-[600]">{PageName}</h1>
        <p className="mb-0 text-[#fff] text-[20px] sm:text-[13px] leading-[26px] sm:max-w-[300px] sm:text-center sm:leading-normal">{t('group.xtstarter1')}</p>

        <PirmaryBtn onClick={onApplyClick} type="primary" size="large" color="#fff" className="mt-[27px] rounded-[8px] sm:rounded-[4px] h-[38px] py-0">{t('group.project')}</PirmaryBtn>
      </section>
    </div>
  );
};

export default observer(withT(PageHeader));
